import React from "react";
import { StyledSVG, Wrapper } from "./IconStyle";
import { useLocation } from "react-router";

export const routeActiveCallCenter = ["call-center"];

const CallCenterIcon = () => {
  const { pathname } = useLocation();
  return (
    <Wrapper>
      {routeActiveCallCenter.some((item) =>
        item.includes(pathname.split("/")[1])
      ) ? (
        <StyledSVG
          width="24"
          height="24"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.2166 5.03244C12.7802 4.95183 12.3794 5.23031 12.2964 5.65626C12.2133 6.08222 12.4926 6.4981 12.9171 6.58146C14.1952 6.83062 15.1821 7.81994 15.4322 9.1024C15.5034 9.47156 15.8284 9.74087 16.2027 9.74087C16.2529 9.74087 16.3031 9.7363 16.3542 9.72713C16.7788 9.64194 17.0581 9.22698 16.975 8.8001C16.6016 6.88467 15.1273 5.40527 13.2166 5.03244Z"
            fill="#637381"
          />
          <path
            d="M13.1597 1.84077C12.9552 1.81145 12.7498 1.87191 12.5864 2.00199C12.4184 2.1339 12.3134 2.32443 12.2906 2.53787C12.2422 2.96932 12.5535 3.35956 12.9844 3.40811C15.9559 3.73971 18.2656 6.05454 18.5997 9.03532C18.6445 9.43472 18.9795 9.73609 19.3793 9.73609C19.4095 9.73609 19.4387 9.73426 19.4688 9.7306C19.6779 9.7077 19.8641 9.60418 19.9956 9.4393C20.1261 9.27441 20.1854 9.06922 20.1617 8.85945C19.7454 5.14033 16.867 2.2539 13.1597 1.84077Z"
            fill="#637381"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.1126 11.8914C13.7693 15.547 14.5988 11.3178 16.927 13.6444C19.1716 15.8884 20.4616 16.3379 17.6178 19.181C17.2616 19.4673 14.9983 22.9114 7.04438 14.9597C-0.910526 7.007 2.53162 4.74141 2.81797 4.38529C5.66871 1.53436 6.11054 2.83193 8.35511 5.07588C10.6833 7.40345 6.45593 8.23571 10.1126 11.8914Z"
            fill="#637381"
          />
        </StyledSVG>
      ) : (
        <svg
          width="24"
          height="24"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask0_5809_13352"
            maskUnits="userSpaceOnUse"
            x="14"
            y="2"
            width="9"
            height="9"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.354 2.00024H22.893V10.5331H14.354V2.00024Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_5809_13352)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M22.1427 10.5331C21.7657 10.5331 21.4417 10.2501 21.3987 9.86706C21.0197 6.49106 18.3977 3.87106 15.0207 3.49606C14.6097 3.45006 14.3127 3.08006 14.3587 2.66806C14.4037 2.25706 14.7707 1.95406 15.1867 2.00606C19.2647 2.45906 22.4317 5.62206 22.8887 9.69906C22.9347 10.1111 22.6387 10.4821 22.2277 10.5281C22.1997 10.5311 22.1707 10.5331 22.1427 10.5331Z"
              fill="#454F5B"
            />
          </g>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.6026 10.5439C18.2506 10.5439 17.9376 10.2959 17.8676 9.93791C17.5796 8.45791 16.4386 7.31691 14.9606 7.02991C14.5536 6.95091 14.2886 6.55791 14.3676 6.15091C14.4466 5.74391 14.8466 5.47791 15.2466 5.55791C17.3276 5.96191 18.9346 7.56791 19.3396 9.64991C19.4186 10.0579 19.1536 10.4509 18.7476 10.5299C18.6986 10.5389 18.6506 10.5439 18.6026 10.5439Z"
            fill="#454F5B"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.28872 4.08785L3.36127 4.01204C5.28869 2.08444 6.54385 1.57351 7.88307 2.34362C8.2683 2.56515 8.62945 2.87523 9.12054 3.37401L10.6269 4.93603C11.4589 5.84393 11.6481 6.71478 11.3772 7.73465L11.3398 7.86967L11.2984 8.00392L11.097 8.59474C10.666 9.91972 10.846 10.6673 12.3795 12.2004C13.9742 13.7947 14.7186 13.9251 16.1457 13.4264L16.4001 13.338L16.7077 13.2381L16.8423 13.2007C17.9263 12.9115 18.842 13.1423 19.8132 14.1128L21.0269 15.2852L21.3842 15.6366C21.7803 16.0405 22.0421 16.3606 22.2355 16.6989C23.0008 18.0377 22.4893 19.2921 20.5063 21.2677L20.3177 21.4589C20.0216 21.7442 19.745 21.9486 19.3386 22.1416C18.6565 22.4655 17.8506 22.5876 16.9142 22.4573C14.6067 22.1364 11.6802 20.3158 7.97188 16.6085C7.67002 16.3067 7.3809 16.0107 7.10425 15.7205L6.56748 15.1476C1.53762 9.68285 1.09389 6.32588 3.15518 4.2205L3.28872 4.08785ZM7.90641 4.28093C7.58062 3.95973 7.34396 3.76394 7.13532 3.64396C6.67379 3.37856 6.1755 3.49074 5.25329 4.28448L4.96353 4.54334C4.91299 4.59 4.86129 4.63843 4.80838 4.68868L4.47611 5.01231L4.44617 5.04972L4.22091 5.27603C3.67656 5.83204 3.41871 6.51064 3.6409 7.67767C4.00551 9.59269 5.67442 12.1905 9.0324 15.5477C12.5313 19.0456 15.1972 20.7041 17.1208 20.9716C18.2422 21.1276 18.8142 20.856 19.3975 20.2584L19.8424 19.8095C20.051 19.5912 20.2292 19.3933 20.3797 19.2126L20.585 18.9539C21.1097 18.2551 21.1576 17.8358 20.9332 17.4433C20.8479 17.2939 20.7237 17.1302 20.5429 16.93L20.2977 16.671L20.1525 16.5258L18.6213 15.0472C18.1096 14.5753 17.7599 14.5084 17.229 14.65L17.0757 14.6941L16.4414 14.9094C14.6013 15.5037 13.2738 15.2155 11.3189 13.2612C9.29429 11.237 9.05685 9.88537 9.73522 7.93917L9.77874 7.81411L9.89908 7.45153L9.95823 7.22043C10.0631 6.71746 9.94337 6.36677 9.40269 5.82601C9.38043 5.80375 9.35555 5.77866 9.32847 5.7512L7.90641 4.28093Z"
            fill="#454F5B"
          />
        </svg>
      )}
    </Wrapper>
  );
};

export default CallCenterIcon;
